export const PAGE_SIZE = 7;
export const BASE_URL = 'https://gotiny.cc/';
